export default Object.freeze({
  TITLE: '네이버페이 취급 제한/불가상품 안내',
	NAVERPAY_LIMIT: '네이버페이 규칙에 의해 매매가 허락되지 않는 ‘취급제한 상품’과 현행 법령상 매매가 금지된 ‘취급불가 상품’은 네이버페이 수단으로 결제할 수 없습니다.',
	CHECK_LIMIT_PRODUCTS: '취급 제한/불가 상품확인하기',

	NAVER_PAY_TOOLTIP_SUB_TITLE: '네이버페이 결제수단에 따른 결제 제한 조건',
	NAVER_PAY_TOOLTIP_NOTICE_ORDER_TYPE: '네이버페이 주문형',
	NAVER_PAY_TOOLTIP_NOTICE_PAYMENT_TYPE: '네이버페이 결제형',
	NAVER_PAY_TOOLTIP_NOTICE_ORDER_TYPE_DESC:
		'\'즉시할인가 (판매가-즉시할인금액) + 옵션가\' 금액이 \'즉시할인가\'금액에 - 50%를 초과',
	NAVER_PAY_TOOLTIP_NOTICE_ORDER_TYPE_DESC2: '하는 상품',
	SERVICE_PRODUCT: '서비스 상품군',
	NAVER_PAY_TOOLTIP_NOTICE_PAYMENT_TYPE_DESC: '총 결제금액 100원 미만',
	EG: '예) 판매가 10,000원 즉시할인금액 2,000원',
	DETAIL_INFO_1: '자세한 사항은 ',
	DETAIL_INFO_2: '네이버페이 센터',
	DETAIL_INFO_3: '에 문의바랍니다.',
	CLOSE: '닫기',
	
	GUIDE_HEADER_1: '즉시할인가',
	GUIDE_HEADER_2: '옵션가',
	GUIDE_HEADER_3: '결제금액',
	GUIDE_HEADER_4: '구매가능 여부',
	WON: '원',
	POSSIBLE: '구매가능',
	NOT_POSSIBLE: '구매불가',
});
